/* loaded by smart-asset */
export default require("./caret-down-solid~NSlXsZRq.svg")